import { formatDistanceToNow, format as fmt, parseISO } from "date-fns";

/**
 * Sanani "5 kun oldin", "Bugun" formatida — uz lokal taxminiy tarjima bilan.
 * date-fns'ning uz locale yo'q (uz-Cyrl bor), shu sabab inglizchadan o'tkazgich.
 */
const REL_MAP: Record<string, string> = {
  "less than a minute ago": "Hozirgina",
  "1 minute ago": "1 daqiqa oldin",
  "about 1 hour ago": "1 soat oldin",
  "about 1 day ago": "Kecha",
  "1 day ago": "Kecha",
  "in less than a minute": "Hozir",
};

export function formatRelative(input: string | Date | null | undefined): string {
  if (!input) return "—";
  const date = typeof input === "string" ? parseISO(input) : input;
  if (Number.isNaN(date.getTime())) return "—";
  const en = formatDistanceToNow(date, { addSuffix: true });
  if (REL_MAP[en]) return REL_MAP[en];
  return en
    .replace(/about /g, "")
    .replace(/ ago/g, " oldin")
    .replace(/ minutes?/g, " daqiqa")
    .replace(/ hours?/g, " soat")
    .replace(/ days?/g, " kun")
    .replace(/ months?/g, " oy")
    .replace(/ years?/g, " yil");
}

export function formatDate(input: string | Date | null | undefined, pattern = "dd-MM-yyyy"): string {
  if (!input) return "—";
  const date = typeof input === "string" ? parseISO(input) : input;
  if (Number.isNaN(date.getTime())) return "—";
  return fmt(date, pattern);
}

export function formatDateTime(input: string | Date | null | undefined): string {
  return formatDate(input, "dd-MM-yyyy HH:mm");
}

/**
 * Slug avto-generate (kebab-case, faqat latin a-z + 0-9 + tire).
 * Cyrl harflar tashlanadi (transliteratsiya yo'q — Faza 4'da react-transliterate).
 */
export function slugify(input: string): string {
  return input
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, "")
    .trim()
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 64);
}

/**
 * Invitation TTL — necha kun/soat qoldi.
 */
export function formatTtl(expiresAt: string): string {
  const expiry = parseISO(expiresAt);
  const now = new Date();
  const ms = expiry.getTime() - now.getTime();
  if (ms <= 0) return "Muddati o'tgan";
  const hours = Math.floor(ms / 3_600_000);
  const days = Math.floor(hours / 24);
  if (days >= 1) {
    const remHours = hours - days * 24;
    return `${days} kun ${remHours} soat qoldi`;
  }
  return `${hours} soat qoldi`;
}
